goog.provide("shadow.js.shim.module$lottie_light_react$default");
shadow.js.shim.module$lottie_light_react$default = shadow.js.require(231, {})["default"];
